import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cargar, seguimiento } from "../carga";

export const fetchTodos = createAsyncThunk("Cursos/fetchTodos", () => cargar('cursos'));

export const fetchCursos = createAsyncThunk("Cursos/fetchCursos", () => cargar('cursos/cursos'));

export const fetchTalleres = createAsyncThunk("Cursos/fetchTalleres", () => cargar('cursos/talleres'));

export const fetchCurso = createAsyncThunk("Cursos/fetchCurso", id => cargar(`cursos/${id}`));

export const CursosSlice = createSlice({
  name: "Cursos",
  initialState: {
    Todos: [],
    Cursos: [],
    Talleres: [],
    loading: false,
    error: null,
    curso: {},
  },
  reducers: {},
  extraReducers: builder => {
    seguimiento(builder, fetchCurso, 'curso');
    seguimiento(builder, fetchCursos, 'Cursos');
    seguimiento(builder, fetchTodos, 'Todos');
    seguimiento(builder, fetchTalleres, 'Talleres');
  },
});


export const {all} = CursosSlice.actions;

export const selector = (state) => state.cursos;

export default CursosSlice.reducer;
